import { render, staticRenderFns } from "./RegistroPers.vue?vue&type=template&id=0db029a2&scoped=true&"
import script from "./RegistroPers.vue?vue&type=script&lang=js&"
export * from "./RegistroPers.vue?vue&type=script&lang=js&"
import style0 from "./RegistroPers.vue?vue&type=style&index=0&id=0db029a2&prod&lang=css&"
import style1 from "./RegistroPers.vue?vue&type=style&index=1&id=0db029a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db029a2",
  null
  
)

export default component.exports